import { ScannerStatus, ScheduleStatus, TargetStatus } from '@rtkwlf/rendall';

import type { NumberStatusOption } from '@packages/fenrir/components';

export const getScannerColor = (value: string): NumberStatusOption => {
  let appearance: NumberStatusOption = 'unassigned';
  switch (value) {
    case ScannerStatus.Scanning:
    case ScannerStatus.Idle:
    case ScannerStatus.Connected:
      appearance = 'low';
      break;
    case ScannerStatus.AwaitingActivation:
    case ScannerStatus.Misconfigured:
    case ScannerStatus.Staged:
      appearance = 'medium';
      break;
    case ScannerStatus.Disconnected:
    case ScannerStatus.Degraded:
    case ScannerStatus.Disabled:
      appearance = 'critical';
      break;
    case ScannerStatus.PreparingToShip:
    case ScannerStatus.Shipped:
    case ScannerStatus.New:
      appearance = 'none';
      break;
    case TargetStatus.Scheduled:
    case ScheduleStatus.Pending:
      appearance = 'high';
      break;
  }
  return appearance;
};
